import { useInternationalization } from '@progress/kendo-react-intl';
import { isUndefined } from 'lodash';
import { useMemo } from 'react';
import ModalContentPreference from 'src/components/ModalContentPreference';
import NumberInput from 'src/components/NumberInput';
import PopUp from 'src/components/design-system/PopUp';
import { getBgColor, getIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import OcrIndicator from '../split_line_item/OcrIndicator';

const GrandTotal = () => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const handleInputChange = useContextSelector(InvoiceContext, (value) => value.handleInputChange);
  const ocrResponse = useContextSelector(InvoiceContext, (value) => value.ocrResponse);
  const initialInvoice = useContextSelector(InvoiceContext, (value) => value.initialInvoice);
  const handleHoverOcrField = useContextSelector(
    InvoiceContext,
    (value) => value.handleHoverOcrField
  );
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings);
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const errors = useContextSelector(InvoiceContext, (value) => value.errors);

  const hasWarning = useMemo(() => !!warnings.totalCostAmt.length, [warnings.totalCostAmt.length]);
  const hasError = useMemo(() => !!errors.totalCostAmt.length, [errors.totalCostAmt.length]);
  const intl = useInternationalization();

  const isEdited = useMemo(
    () => Number(ocrResponse.amountDue?.value || 0) !== Number(invoice?.totalCostAmt || 0),
    [invoice?.totalCostAmt, ocrResponse.amountDue?.value]
  );

  return (
    <PopUp
      content={
        <ModalContentPreference
          hasWarning={hasWarning}
          hasError={hasError}
          warningContent={warnings.totalCostAmt}
          errorContent={errors.totalCostAmt}
        />
      }
      show={hasError || hasWarning}
      popupAlign={{ horizontal: 'center', vertical: 'bottom' }}
      anchorAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <div className={`p-1 ${getBgColor(errors.totalCostAmt, warnings.totalCostAmt)} text-[13px]`}>
        <div className="flex justify-between max-w-[177px] flex-grow">
          <p className="font-bold flex items-center pb-1">
            Grand Total
            <span className="px-2">{getIcon(errors.totalCostAmt, warnings.totalCostAmt)}</span>
          </p>

          {initialInvoice?.ocrGenerated && ocrResponse.amountDue?.confidence && (
            <OcrIndicator
              isEdited={isEdited}
              ocrConfidence={ocrResponse.amountDue?.confidence}
              onHover={() => handleHoverOcrField('amountDue')}
            />
          )}
        </div>
        {isInvoiceEditDisabled ? (
          <p title={invoice?.totalCostAmt?.toString() || ''}>
            {intl.format('{0:c2}', Number(invoice?.totalCostAmt) || 0)}
          </p>
        ) : (
          <NumberInput
            title={invoice?.totalCostAmt?.toString() || ''}
            value={
              isUndefined(invoice?.totalCostAmt.toString()) ? '' : invoice?.totalCostAmt.toString()
            }
            onChange={handleInputChange('totalCostAmt')}
            prefix="$"
            valid={!(hasWarning || hasError)}
            onFocus={() => handleHoverOcrField('amountDue')}
            ocr-data="amountDue"
          />
        )}
      </div>
    </PopUp>
  );
};

export default GrandTotal;
